import React from 'react';
import { Target } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-slate-50 py-20 px-6 border-t border-slate-100">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
        <div className="col-span-1 md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <div className="bg-royal-dark p-2 rounded-xl">
              <Target className="text-royal-gold w-6 h-6" />
            </div>
            <div className="flex flex-col">
              <span className="font-display font-black text-2xl text-royal-dark tracking-tighter uppercase leading-none">
                DELIGHT BUSINESS
              </span>
              <span className="text-[10px] font-bold text-royal-purple tracking-[0.2em] leading-none mt-1">
                EMPOWERMENT
              </span>
            </div>
          </div>
          <p className="text-slate-500 max-w-sm font-medium leading-relaxed">
            Delight Business Empowerment is a purpose-driven platform committed to inspiring, supporting, and empowering
            individuals and businesses to grow, succeed, and reach their full potential.
          </p>
        </div>
        <div>
          <h4 className="font-black text-royal-dark mb-6 uppercase tracking-widest text-xs">Quick Links</h4>
          <ul className="space-y-4 text-sm font-bold text-slate-500">
            <li>
              <Link to="/" className="hover:text-royal-purple transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link to="/faces" className="hover:text-royal-purple transition-colors">
                Delight Business Empowerment
              </Link>
            </li>
            <li>
              <Link to="/register" className="hover:text-royal-purple transition-colors">
                Register for Contest
              </Link>
            </li>
            <li>
              <Link to="/vote" className="hover:text-royal-purple transition-colors">
                Vote for Contestants
              </Link>
            </li>
            <li>
              <Link to="/programs" className="hover:text-royal-purple transition-colors">
                Programs
              </Link>
            </li>
            <li>
              <Link to="/impact" className="hover:text-royal-purple transition-colors">
                Impact
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-black text-royal-dark mb-6 uppercase tracking-widest text-xs">Connect</h4>
          <ul className="space-y-4 text-sm font-bold text-slate-500">
            <li>
              <a href="#" className="hover:text-royal-purple transition-colors">
                Instagram
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-royal-purple transition-colors">
                Twitter (X)
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-royal-purple transition-colors">
                LinkedIn
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-royal-purple transition-colors">
                Facebook
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-slate-400 text-[10px] font-black uppercase tracking-[0.2em]">
          &copy; 2025 Delight Business Empowerment Initiative. All Rights Reserved.
        </p>
        <div className="flex gap-6 text-[10px] font-black text-slate-400 uppercase tracking-widest">
          <Link to="/terms" className="hover:text-royal-dark transition-colors">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-royal-dark transition-colors">
            Privacy
          </Link>
          <Link to="/cookies" className="hover:text-royal-dark transition-colors">
            Cookies
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
